import React, { forwardRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Modal,
  Item,
} from "@material-ui/core";
// styles
import jwt_decode from "jwt-decode";
import moment from "moment";
import classnames from "classnames";
import useStyles from "./styles";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { useTheme } from "@material-ui/core/styles";
import axios from "axios";
import { DeleteForever, FileCopy, Launch } from "@material-ui/icons";
import useResponsiveSize from "../../utils/useResponsiveSize";
import { toast } from "material-react-toastify";

import MaterialTable from "material-table";
import {
  AddBox,
  ArrowUpward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { useLayoutState } from "../../context/LayoutContext";
import PageTitle from "../../components/Header/PageTitle/PageTitle";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export default function Dashboard() {
  const theme = useTheme();
  const token = localStorage.getItem("signinToken");
  let user;
  if (token) {
    var decodedHeader = jwt_decode(localStorage.getItem("signinToken"));
    user = decodedHeader?.user;
  }

  var classes = useStyles();
  var layoutState = useLayoutState();

  const [fullname, setFullname] = useState("");
  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const getUsers = async () => {
    const userlist = await axios.post(
      // "https://nowevents.herokuapp.com/user-list"
      "https://nowevents.herokuapp.com/get-my-meeting",
      {
        user: user?._id,
      }
    );
    setUsers(userlist?.data?.user?.reverse());
  };

  useEffect(() => {
    getUsers();
  }, []);
  const padding = useResponsiveSize({
    xl: 6,
    lg: 6,
    md: 6,
    sm: 4,
    xs: 1.5,
  });
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "black",
    border: "0px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
  };

  const add = async () => {
    if (fullname === "") {
      toast.error("Full name is required");
    } else if (email === "") {
      toast.error("Enter email address");
    } else if (password === "") {
      toast.error("Enter your password");
    } else {
      axios
        .post("https://nowevents.herokuapp.com/create", {
          name: fullname,
          email: email,
          password: password,
        })
        .then((r) => {
          if (r?.data?.user === "email is taken") {
            toast.error("email is taken");
          } else {
            toast.success("User added successfully");
            setShow(!show);
            getUsers();
          }
        });
    }
  };
  return (
    <>
      {" "}
      <Modal
        open={show}
        onClose={() => {
          setShow(!show);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            container
            spacing={padding}
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              // backgroundColor: "purple",
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{
                width: "100%",
                display: "flex",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",

                // backgroundColor: "pink",
              }}
            >
              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box mt={0} style={{ width: "100%" }}>
                  <TextField
                    autoComplete={false}
                    id={"inputJoin"}
                    value={fullname}
                    placeholder="Enter name"
                    // helperText="Your name will help everyone identify you in the meeting"
                    variant="outlined"
                    fullWidth
                    // value={name}

                    onChange={(ev) => {
                      setFullname(ev.target.value);
                    }}
                  />
                </Box>
              </Box>
              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  flex: 1,
                  marginTop: 10,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box mt={0} style={{ width: "100%" }}>
                  <TextField
                    autoComplete={false}
                    id={"inputJoin"}
                    value={email}
                    placeholder="Enter email address"
                    // helperText="Your name will help everyone identify you in the meeting"
                    variant="outlined"
                    fullWidth
                    // value={name}
                    type={"email"}
                    onChange={(ev) => {
                      setEmail(ev.target.value);
                    }}
                  />
                </Box>
              </Box>
              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 10,
                }}
              >
                <Box mt={0} style={{ width: "100%" }}>
                  <TextField
                    id={"inputJoin"}
                    placeholder="Enter your password"
                    // helperText="Your name will help everyone identify you in the meeting"
                    variant="outlined"
                    // error={true}

                    fullWidth
                    value={password}
                    type={"password"}
                    onChange={(ev) => {
                      setPassword(ev.target.value);
                    }}
                  />
                </Box>
              </Box>
              <Button
                style={{ marginTop: 10, width: "100%" }}
                variant="contained"
                onClick={add}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <div className={classes.root}>
        <Header />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          
        {/* {user?.role!=="member" &&  <PageTitle
            button={
              <Button
                onClick={() => {
                  setShow(!show);
                }}
                variant="contained"
                size="medium"
                color="secondary"
              >
                Add Member
              </Button>
            }
          />} */}
          <Grid container spacing={4}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <MaterialTable
                icons={tableIcons}
                localization={{ toolbar: { searchPlaceholder: "Search " } }}
                title=""
                columns={[
                  { title: "Name", field: "name" },
                  // { title: "Email", field: "email" },
                  // { title: "Role", field: "role" },
                  {
                    title: "Created",
                    render: (row) => {
                      return (
                        <p>{moment(row?.createdAt).format("MM/DD/YYYY")}</p>
                      );
                    },
                  },
                  {
                    title: "URL",
                    width: "75%",
                    render: (row) => {
                      return (
                        <TextField
                          id={"inputJoin"}
                          placeholder="Enter meeting id or create meeting id"
                          variant="outlined"
                          fullWidth
                          disabled
                          value={row?.link}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => {
                                    window.open(
                                      `${row?.link}`,
                                      "__blank"
                                    );
                                  }}
                                >
                                  <Button
                                    color="primary"
                                    variant="contained"
                                    //   onClick={startMeeting}
                                    onClick={(e) => {
                                      localStorage.setItem(
                                        "meetingToken",
                                        row?.token
                                      );
                                      window.open(
                                        `${row?.link}`,
                                        "__blank"
                                      );
                                    }}
                                    id={"btnJoin"}
                                  >
                                    START
                                  </Button>
                                </IconButton>
                                <CopyToClipboard
                                  text={row?.link}
                                  onCopy={() =>
                                    toast.success("Link copied successfully")
                                  }
                                >
                                  <IconButton>
                                    <FileCopy
                                      style={{
                                        color:
                                          theme.palette.primary.contrastText,
                                      }}
                                    />
                                  </IconButton>
                                </CopyToClipboard>
                              </InputAdornment>
                            ),
                          }}
                        />
                      );
                    },
                  },
                  {
                    title: "Start Time",
                    render: (i) => {
                      return (
                        <p>
                          {" "}
                          {moment(i?.create).fromNow()}{" "}
                          {moment(i?.create).format("hh:mm A")}
                        </p>
                      );
                    },
                  },
                  {
                    title: "Action",

                    render: (i) => {
                      return (
                        <p>
                          <IconButton
                            onClick={() => {
                              axios
                                .post(
                                  "https://nowevents.herokuapp.com/delete-meeting-link",
                                  { meetingId: i?.meetingId }
                                )
                                .then((r) => {
                                  getUsers();
                                });
                            }}
                          >
                            <DeleteForever
                              style={{
                                color: theme.palette.primary.contrastText,
                              }}
                            />
                          </IconButton>
                        </p>
                      );
                    },
                  },
                ]}
                data={users}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}
